import { useState, useCallback } from 'react';
import { ConfirmDialogState } from '../../../types/FormTypes';

/**
 * Hook for managing form dialogs and confirmations
 * Single responsibility: Dialog state management
 */
export const useFormDialog = () => {
    const [errorDialog, setErrorDialog] = useState<string>('');
    const [confirmDialogState, setConfirmDialogState] = useState<ConfirmDialogState | null>(null);

    const openConfirmationDialog = useCallback((title: string, message: string, onConfirm: () => Promise<void>, onCancel?: () => void) => {
        setConfirmDialogState({
            isOpen: true,
            title,
            message,
            onConfirm,
            onCancel,
        });
    }, []);

    const closeConfirmationDialog = useCallback(() => {
        setConfirmDialogState(null);
    }, []);

    const clearError = useCallback(() => {
        setErrorDialog('');
    }, []);

    return {
        errorDialog,
        setErrorDialog,
        confirmDialogState,
        openConfirmationDialog,
        closeConfirmationDialog,
        clearError,
    };
};

export type UseFormDialogReturn = ReturnType<typeof useFormDialog>;
